import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FieldType } from './lock-field.dto';
import { GlobalService } from 'app/global/global.service';

@Component({
  selector: 'app-lock-field',
  templateUrl: './lock-field.component.html',
  styleUrl: './lock-field.component.scss'
})
export class LockFieldComponent implements OnChanges {
  @Input() uuid;
  @Input() type = FieldType.FIELD; // or FieldType.BLOCK
  @Output() lockChange = new EventEmitter<boolean>();

  constructor(private globalService: GlobalService) {}
  public isLocked: boolean = false;
  ngOnChanges() {
    let isLocked = 0;
    if (this.type === FieldType.FIELD) {
      isLocked = this.globalService.fields_data[this.uuid]?.is_locked ?? 0;
    } else if (this.type === FieldType.BLOCK) {
      isLocked = this.globalService.fields_data['blocks'][this.uuid]?.is_locked ?? 0;
    }
    this.isLocked = isLocked === 1 ? true : false;
  }

  onChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.updateLockStatus(checked);
    this.lockChange.emit(checked);
  }

  private updateLockStatus(checked: boolean) {
    if(this.type === FieldType.FIELD) {
      this.globalService.updateField(this.uuid, { is_locked: checked ? 1 : 0 })
    }else if(this.type === FieldType.BLOCK) {
      this.globalService.updateBlock(this.uuid, { is_locked: checked ? 1 : 0 });
    }
  }
}
